<template>
  <div class="m-auto max-w-screen-lg shadow" @mouseout="update({ hoveredMode: 'all' })">
    <nav class="relative z-20 flex items-center justify-between bg-gray-900 font-bold">
      <div class="flex px-2 py-1 items-center text-sm lg:text-base text-white uppercase">
        <img class="h-8 mr-2" src="../assets/logo.png" alt />
        <span class="hidden sm:inline">Diabotical</span>
        <span class="mx-2">Leaderboards</span>
      </div>
      <div>
        <div class="px-3 py-1 rounded bg-blue-600 hover:bg-blue-500 text-white font-bold text-sm uppercase cursor-pointer" @click="update({ modalCountries: true })"><i class="fa fa-list-ol" />&nbsp;Countries</div>
      </div>
      <!-- <a class="p-2 underline text-blue-400 hover:text-blue-200" href="https://www.reddit.com/r/Diabotical/comments/k2gua8/patch_notes_version_020421_november_27_2020_queue/" target="_blank">No updates anymore?</a> -->
      <div class="active flex lg:hidden justify-center items-center p-2 text-sm font-bold uppercase cursor-pointer" @click.stop="toggleDropdown()">{{ datesByName[date] }}</div>
      <div class="hidden lg:flex text-gray-500">
        <div class="date p-2 cursor-pointer hover:text-white" :class="{ 'text-yellow-400': day === date, 'text-orange-200': day.includes('2020-12-29') }" v-for="(dayName, day) in datesByName" :key="day" :title="day" @click="updateData(day)">
          {{ dayName }}
        </div>
        <div class="p-2 text-gray-700">{{ updateCounter }}</div>
      </div>
    </nav>
    <div class="relative z-20 flex divide-x divide-gray-700 divide-opacity-25 bg-gray-800 text-white text-center">
      <div class="flex-1 flex items-center flex-shrink-0">
        <input ref="input" class="w-full p-2 text-sm text-gray-800" :class="{ 'bg-yellow-200': search }" type="text" placeholder="Search" v-model="search" />
      </div>
      <div class="active flex lg:hidden justify-center items-center p-2 text-sm font-bold uppercase cursor-pointer" @click.stop="toggleDropdown()">{{ sortModeName }} / {{ sortFieldName }}</div>
      <div class="col hidden lg:flex flex-col py-2 justify-center cursor-pointer" v-for="mode in modes" :key="mode.id" :title="mode.title" @click.stop="sortBy(`${mode.id}.rating`)" @mouseover="update({ hoveredMode: mode.newId })">
        <div class="mode text-sm font-bold uppercase" :class="getSortClass(mode.id)">{{ mode.name }}</div>
        <div class="sorts flex justify-center text-xs text-gray-500">
          <div class="px-1 hover:text-white" :class="getSortClass(`${mode.id}.rating`)" @click.stop="sortBy(`${mode.id}.rating`)">Rating</div>
          <div class="px-1 hover:text-white" :class="getSortClass(`${mode.id}.matches`)" @click.stop="sortBy(`${mode.id}.matches`)">Matches</div>
        </div>
      </div>
    </div>
    <div class="relative">
      <div class="row bg-gray-400" v-for="player in stickedPlayers" :key="player.id">
        <LeaderboardPlayer class="sticked" :index="null" :source="player" />
      </div>
      <div class="dropdown absolute top-0 inset-x-0 text-white text-center" :class="{ visible: dropdown }">
        <div class="flex flex-wrap bg-gray-700">
          <div class="w-1/2 md:w-1/4 flex flex-col justify-center cursor-pointer" v-for="mode in modes" :key="mode.id" :title="mode.title">
            <div class="pt-4 p-2 font-bold uppercase" :class="getSortClass(mode.id)" @click="sortBy(`${mode.id}.rating`)">{{ mode.name }}</div>
            <div class="flex justify-center text-gray-500">
              <div class="flex-1 pt-2 pb-3 hover:text-white" :class="getSortClass(`${mode.id}.rating`)" @click="sortBy(`${mode.id}.rating`)">Rating</div>
              <div class="flex-1 pt-2 pb-3 hover:text-white" :class="getSortClass(`${mode.id}.matches`)" @click="sortBy(`${mode.id}.matches`)">Matches</div>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-center bg-gray-600 text-lg font-bold">
          <div class="p-4 cursor-pointer hover:text-white" :class="{ 'text-yellow-400': day === date, 'text-orange-200': day.includes('2020-12-29') }" v-for="(dayName, day) in datesByName" :key="day" :title="day" @click="updateData(day)">
            {{ dayName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import LeaderboardPlayer from './LeaderboardPlayer.vue'

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  export default {
    name: 'LeaderboardHeader',
    components: { LeaderboardPlayer },
    data() {
      return {
        search: '',
        updateCounter: 'Update in 00:00:00',
      }
    },
    computed: {
      ...mapState(['filter', 'date', 'dates', 'dropdown']),
      ...mapGetters(['stickedPlayers', 'sortMode', 'sortField', 'modes', 'sort']),
      sortModeName() {
        return this.modes.find(mode => mode.id === this.sortMode).name
      },
      sortFieldName() {
        return this.sortField.substr(0, 1).toUpperCase() + this.sortField.substr(1)
      },
      datesByName() {
        const datesByName = {}
        if (this.dates.length) {
          const today = new Date().toISOString().substr(0, 10)
          const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString().substr(0, 10)
          for (const ISOdate of this.dates) {
            const date = new Date(ISOdate)
            datesByName[ISOdate] = ISOdate.includes('2020-12-29') ? 'Season 1' : monthNames[date.getUTCMonth()] + ' ' + date.getUTCDate()
          }
          if (this.dates[this.dates.length - 1].includes(today)) {
            datesByName[this.dates[this.dates.length - 1]] = 'Today'
          }
          if (this.dates[this.dates.length - 2].includes(yesterday)) {
            datesByName[this.dates[this.dates.length - 2]] = 'Yesterday'
          }
        }
        return datesByName
      },
    },
    watch: {
      search(newValue) {
        this.updateFilter({ name: newValue })
      },
    },
    methods: {
      ...mapActions(['sortBy', 'update', 'updateFilter', 'updateData', 'fetchDates', 'toggleDropdown']),
      getSortClass(sort) {
        const [mode, field] = sort.split('.')
        return {
          active: field ? this.sort === sort : this.sort.includes(mode),
        }
      },
      updateTimer() {
        const durationDate = new Date(new Date(new Date().toISOString().substr(0, 10)).getTime() + 24 * 60 * 60 * 1000 - Date.now() + 30000)
        const hours = durationDate.getUTCHours()
        const minutes = durationDate.getUTCMinutes()
        const seconds = durationDate.getUTCSeconds()
        if (hours === 23 && minutes === 59) {
          this.updateCounter = 'Update in progress'
          if (seconds === 0) {
            this.updateCounter = 'Downloading data'
            this.fetchDates()
          }
        } else {
          this.updateCounter = 'Update in ' + (hours < 10 ? `0${hours}` : hours) + ':' + (minutes < 10 ? `0${minutes}` : minutes) + ':' + (seconds < 10 ? `0${seconds}` : seconds)
        }
      },
    },
    mounted() {
      this.$refs.input.focus()
      this.$options.counter = setInterval(this.updateTimer, 1000)
    },
    beforeDestroy() {
      clearInterval(this.$options.counter)
    },
  }
</script>

<style scoped>
  .col:hover .mode {
    display: none;
  }
  .col:hover .sorts {
    display: flex;
  }
  .sorts {
    display: none;
  }
  .active {
    color: #f6e05e !important;
  }
  .dropdown {
    transform: translate(0, -100%);
    transition: transform 0.3s ease;
  }
  .dropdown.visible {
    transform: translate(0, 0);
  }
</style>
